import { render, staticRenderFns } from "./CountrySelector.vue?vue&type=template&id=229f44b3&"
import script from "./CountrySelector.vue?vue&type=script&lang=js&"
export * from "./CountrySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports